export const exportNames = {
  selectReport: "Select Report",
  woundEvaluations: "Wound Evaluations",
  surveillance: "Surveillance",
  patientList: "Patient List",
  patientHistory: "Patient History"
};
